import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MeasuringPoint} from '../../../models/measuring-point.model';
import {MeasuringPointService} from '../../../services/model/measuring-point.service';
import {PageTest} from "../../../utilities/PageTest";
import {ROUTING} from "../../../utilities/routing-constants";
import {AdminLayoutComponent} from "../../../layouts/admin-layout/admin-layout.component";
import {AbstractShowPage} from "../../../models/AbstractShowPage";
import {MyStorageService} from "../../../services/my-storage.service";

@Component({
  selector: 'app-show-measuring-points',
  templateUrl: './show-measuring-points.component.html',
  styleUrls: ['./show-measuring-points.component.scss']
})
@PageTest({
  path: 'show/:id',
  pathPrefix: ROUTING.MeasuringPoint.basePlural,
  layout: AdminLayoutComponent
})
export class ShowMeasuringPointsComponent extends AbstractShowPage<MeasuringPoint, MeasuringPointService> implements OnInit {

  constructor(service: MeasuringPointService, route: ActivatedRoute,
              myStorageService:MyStorageService) {
    super(service, route, myStorageService);
  }

  ngOnInit(): void {
    this.onInit();
  }

  ngOnDestroy(): void {
    this.onDestroy();
  }

}
